import { siteStats } from "@/mocks/gossip";

const quickEntries = [
  { href: "#hot", icon: "ri-fire-line", title: "今日热议榜", desc: "看看现在大家在聊什么" },
  { href: "#forum", icon: "ri-layout-grid-line", title: "进吃瓜论坛", desc: "按兴趣板块蹲守讨论" },
  { href: "#group", icon: "ri-group-line", title: "吃瓜群入口", desc: "实时跟上群里的节奏" },
  { href: "#live", icon: "ri-radar-line", title: "围观现场", desc: "按时间线回看热度走向" },
];

export default function HeroSection() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20warm%20dark%20crimson%20and%20amber%20gradient%20texture%20with%20soft%20grain%2C%20subtle%20glow%20patches%2C%20cinematic%20editorial%20background%2C%20no%20text%2C%20minimal%20modern%20poster%20style&width=1920&height=1080&seq=gossip-hero-01&orientation=landscape"
          alt=""
          className="h-full w-full object-top object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/65"></div>
      </div>

      <div className="relative mx-auto w-full px-4 md:px-6 pt-14 pb-8 md:pt-20 md:pb-10">
        <div className="mx-auto max-w-4xl text-center animate-fade-up">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-xs md:text-sm text-white/90 backdrop-blur">
            <i className="ri-eye-line w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
            吃瓜群众 · 围观现场 · 尽在这里
          </span>
          <h1 className="mt-5 font-heading text-3xl md:text-5xl font-bold leading-tight text-white">
            黑料吃瓜网 · 吃瓜群众的围观聚集地
          </h1>
          <p className="mx-auto mt-5 max-w-2xl text-sm md:text-base leading-relaxed text-white/85">
            这里是吃瓜论坛与吃瓜群的入口，聚合今日热议、最新讨论动态与分类板块。
            无论你想围观综艺现场、追踪新剧口碑，还是只想安安静静看热闹，
            都能在这一页找到属于自己的吃瓜座位。
          </p>
          <div className="mt-7 flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#hot"
              className="flex w-full sm:w-auto items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 dark:text-foreground-950 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-fire-line w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
              先看今日热议
            </a>
            <a
              href="#forum"
              className="flex w-full sm:w-auto items-center justify-center gap-2 rounded-md border border-white/30 bg-white/5 px-6 py-3 text-sm font-medium text-white hover:bg-white/15 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-layout-grid-line w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
              进吃瓜论坛
            </a>
          </div>
        </div>

        <div className="mx-auto mt-10 grid max-w-4xl grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {siteStats.map((stat) => (
            <div key={stat.label} className="rounded-lg border border-white/15 bg-white/5 px-4 py-3 text-center backdrop-blur-sm">
              <div className="font-heading text-lg md:text-2xl font-bold text-white">{stat.value}</div>
              <div className="mt-1 text-xs text-white/70">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="relative mx-auto w-full px-4 md:px-6 pb-12 md:pb-16">
        <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
          <div className="flex items-center justify-between gap-3">
            <div className="flex items-center gap-2">
              <span className="flex items-center justify-center w-6 h-6 rounded-md bg-accent-100 text-accent-800">
                <i className="ri-corner-down-right-line text-sm" aria-hidden="true"></i>
              </span>
              <span className="text-sm font-medium text-foreground-900">快速入口</span>
            </div>
            <span className="hidden sm:block text-xs text-foreground-500">点一下，直接去到对应分区</span>
          </div>
          <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
            {quickEntries.map((entry) => (
              <a
                key={entry.href}
                href={entry.href}
                className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-100 px-4 py-3 transition-colors hover:border-primary-300 hover:bg-primary-50 cursor-pointer"
              >
                <span className="flex items-center justify-center w-10 h-10 shrink-0 rounded-md bg-background-50 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 dark:group-hover:text-foreground-950 transition-colors">
                  <i className={`${entry.icon} text-lg`} aria-hidden="true"></i>
                </span>
                <span className="leading-tight">
                  <span className="block text-sm font-medium text-foreground-900">{entry.title}</span>
                  <span className="block text-xs text-foreground-500">{entry.desc}</span>
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}